export const LOGIN_USER = "LOGIN_USER"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_FAILED = "LOGIN_FAILED"

export const LOGOUT_USER = "LOGOUT_USER"
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS"
export const API_ERROR = "LOGIN_API_ERROR"
export const SOCIAL_LOGIN = "SOCIAL_LOGIN"
export const LOGIN_USER_RESET = "LOGIN_USER_RESET"
export const RESET_LOGIN_RESPONSE_MSG = "RESET_LOGIN_RESPONSE_MSG"
export const FETCH_CONST_DETAILS = "FETCH_CONST_DETAILS"
export const SET_CONST_DETAILS = "SET_CONST_DETAILS"
export const LOGOUT_USER_FAILED = "LOGOUT_USER_FAILED"
export const SESSION_TIMEOUT = "SESSION_TIMEOUT"
